import React, { useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
} from "../../../_metronic/_helpers";
import { useDispatch } from "react-redux";

import { useHistory } from "react-router-dom";
import {
  formatDate,
  sizePerPageList,
  showSuccessDialog,
  showErrorDialog,
  showDeleteDialog,
  activeFormatter,
} from "../../utility";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import { removeMenu } from "./menuSlice";

export const MenuTable = ({
  data,
  page,
  sizePerPage,
  onTableChange,
  totalSize,
  loading,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    // Add number
    const pageBefore = sizePerPage * (page - 1);
    const initData = data.map((item, index) => {
      return {
        ...item,
        no: index + 1 + pageBefore,
      };
    });
    setTableData(initData);
  }, [data, sizePerPage, page]);

  const [tableData, setTableData] = useState(data);

  const handleDelete = async (e, row) => {
    const params = { menu_id: `${row.menu_id}` };
    const action = await showDeleteDialog(`Are you sure you want to delete?`);
    if (action.isConfirmed) {
      try {
        const response = await dispatch(removeMenu({ data: params }));
        if (response.payload.data.status === 200) {
          const action = await showSuccessDialog(response.payload.data.message);
          // await handleSearch();
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const actionFormatter = (cell, row) => {
    return (
      <div>
        <OverlayTrigger
          overlay={<Tooltip id="products-edit-tooltip">Edit</Tooltip>}
        >
          <div
            className="btn btn-icon btn-light btn-hover-primary btn-sm mr-3"
            onClick={() => {
              history.push(
                "/administration/bussiness-parameter/parameter/edit"
              );
            }}
          >
            <span className="svg-icon svg-icon-md svg-icon-primary">
              <SVG src={toAbsoluteUrl("/media/svg/icons/New/edit.svg")} />
            </span>
          </div>
        </OverlayTrigger>
        <span className="mx-2"></span>
        <OverlayTrigger
          overlay={<Tooltip id="products-delete-tooltip">Delete</Tooltip>}
        >
          <div
            className="btn btn-icon btn-light btn-hover-danger btn-sm"
            onClick={(e) => handleDelete(e, row)}
          >
            <span className="svg-icon svg-icon-md svg-icon-danger">
              <SVG src={toAbsoluteUrl("/media/svg/icons/New/delete.svg")} />
            </span>
          </div>
        </OverlayTrigger>
      </div>
    );
  };
  const columns = [
    {
      text: "No",
      dataField: "no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "60px" },
    },
    {
      text: "Name",
      dataField: "menu_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "TItle",
      dataField: "title",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "url",
      dataField: "menu_url",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },

    {
      text: "Created Date",
      dataField: "created_date",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: formatDate,
      style: { minWidth: "150px" },
    },

    {
      text: "Action",
      dataField: "action",
      formatter: actionFormatter,
    },
  ];

  const options = {
    page: page,
    sizePerPage: sizePerPage,
    showTotal: true,
    totalSize: totalSize,
    sizePerPageList: sizePerPageList(totalSize),
  };

  return (
    <>
      <BootstrapTable
        remote
        wrapperClasses="table-responsive"
        classes="table table-head-custom table-vertical-center overflow-hidden"
        bootstrap4
        
        keyField="param_id"
        data={tableData}
        columns={columns}
        pagination={paginationFactory(options)}
        onTableChange={onTableChange}
        hover
      >
        <PleaseWaitMessage entities={loading ? null : tableData} />
        <NoRecordsFoundMessage entities={loading ? null : tableData} />
      </BootstrapTable>
    </>
  );
};
